export default class PossibleState {

	public name: string | null = null;
	public code: string | null = null;
	public isRiskAllowed: boolean | null = null;

	public constructor() {
		
	}
};